// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payjp-page {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(128, 128, 128, 0.219);
  position: relative;
}
.payjp-page .payjp-page-icon {
  position: absolute;
  left: 5px;
  font-size: 20px;
  width: 30px;
  height: 30px;
  background-color: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.payjp-page .payjp-page-icon:hover {
  background-color: rgba(128, 128, 128, 0.137);
  cursor: pointer;
}

.payjp-page-bank {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(128, 128, 128, 0.219);
  gap: 20px;
}
.payjp-page-bank img {
  height: 40px;
  border-radius: 4px;
  object-fit: contain;
}

.payjp-page-item {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 50px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.219);
  font-weight: 500;
  width: 100%;
}
.payjp-page-item .payjp-page-item-title {
  width: 100%;
  max-width: 80px;
  min-width: 80px;
  font-size: 15px;
}
.payjp-page-item .payjp-page-item-input {
  display: flex;
}
.payjp-page-item .payjp-page-item-input input {
  outline: none;
  border: none;
  font-size: 17px;
}
.payjp-page-item .payjp-page-item-input-50 input {
  width: 25px;
  display: flex;
  align-items: center;
  padding: 0px 5px;
  font-size: 17px;
}
.payjp-page-item .payjp-page-item-input-60 input {
  width: 35px;
  display: flex;
  align-items: center;
  padding: 0px 5px;
  font-size: 17px;
}
.payjp-page-item .payjp-page-hr {
  height: 40px;
  width: 1px;
  background-color: rgba(128, 128, 128, 0.219);
}

.payjp-page-layout {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/pages/register/PayJPPage.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;EACA,kBAAA;AACJ;AAAI;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAER;AAAI;EACI,4CAAA;EACA,eAAA;AAER;;AACA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;EACA,SAAA;AAEJ;AADI;EACI,YAAA;EACA,kBAAA;EACA,mBAAA;AAGR;;AACA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mDAAA;EACA,gBAAA;EACA,WAAA;AAEJ;AADI;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AAGR;AADI;EACI,aAAA;AAGR;AAFQ;EACI,aAAA;EACA,YAAA;EACA,eAAA;AAIZ;AAAQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAEZ;AAEQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAAZ;AAGI;EACI,YAAA;EACA,UAAA;EACA,4CAAA;AADR;;AAIA;EACI,aAAA;AADJ","sourcesContent":[".payjp-page{\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-bottom: 1px solid rgba(128, 128, 128, 0.219);\n    position: relative;\n    .payjp-page-icon{\n        position: absolute;\n        left: 5px;\n        font-size: 20px;\n        width: 30px;\n        height: 30px;\n        background-color: white;\n        border-radius: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .payjp-page-icon:hover{\n        background-color: rgba(128, 128, 128, 0.137);\n        cursor: pointer;\n    }\n}\n.payjp-page-bank{\n    height: 70px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-bottom: 1px solid rgba(128, 128, 128, 0.219);\n    gap: 20px;\n    img{\n        height: 40px;\n        border-radius: 4px;\n        object-fit: contain;\n        // max-width: calc(16% - 20px);\n    }\n}\n.payjp-page-item{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    height: 50px;\n    border-bottom: 1px solid rgba(128, 128, 128, 0.219);\n    font-weight: 500;\n    width: 100%;\n    .payjp-page-item-title{\n        width: 100%;\n        max-width: 80px;\n        min-width: 80px;\n        font-size: 15px;\n    }\n    .payjp-page-item-input{\n        display: flex;\n        input{\n            outline: none;\n            border: none;\n            font-size: 17px;\n        }\n    }\n    .payjp-page-item-input-50{\n        input{\n            width: 25px;\n            display: flex;\n            align-items: center;\n            padding: 0px 5px;\n            font-size: 17px;\n        }\n    }\n    .payjp-page-item-input-60{\n        input{\n            width: 35px;\n            display: flex;\n            align-items: center;\n            padding: 0px 5px;\n            font-size: 17px;\n        }\n    }\n    .payjp-page-hr{\n        height: 40px;\n        width: 1px;\n        background-color: rgba(128, 128, 128, 0.219);\n    }\n}\n.payjp-page-layout{\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
